import React from 'react'
import { useAuth } from 'react-oidc-context'

export const OpenButton = ({ url, children, className }) => {
  const auth = useAuth()

  return (
    <a
      className={className}
      href={`${url}?access_token=${auth.user?.access_token}`}
      target="_blank"
      rel="noreferrer noopener"
    >
      {children}
    </a>
  )
}
